module.exports = __webpack_public_path__ + "static/media/fresenius-B.cab15813.png";